export class Variavel{
  id: number;
  identificador: string;
  descricao: string;
  tipo_id: string;
  usado: boolean = false;
  padrao: boolean = false;
  destroy: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/variaveis/variavel.ts